import Tooltip from "react-tooltip";
import { InformationCircleIcon } from "@heroicons/react/24/solid";

const DashboardCard2 = ({ image, text, count, hasAccess }) => {
  var message =
    "Contact your System Administrator to secure access to this module.";
  return (
    <>
      <div className="flex w-full justify-between items-center">
        <div className="flex w-full gap-2 items-center">
          <div>{image}</div>
          <div className="flex w-full">
            <h3 className="3xl:text-xl 2xl:text-md lg:text-sm md:text-sm sm:text-xs text-white text-white uppercase">
              {text}
            </h3>
          </div>
          <div className="">
            {hasAccess ? (
              <h1 className="font-bold text-white text-lg 2xl:text-xl lg:text-lg md:text-md">
                {count}
              </h1>
            ) : (
              <span data-tip={message}>
                <div className="w-full">
                  <Tooltip
                    title={message}
                    placement="top-start"
                    effect="solid"
                    type="info"
                    border={true}
                    arrowColor="white"
                    borderColor="#0078d7"
                    backgroundColor="white"
                    textColor="#0078d7"
                  />
                </div>
              </span>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default DashboardCard2;
